import { Box, CircularProgress, Typography } from '@mui/material';
import { motion, useReducedMotion } from 'framer-motion';
import PropTypes from 'prop-types';

type InitialPageLoaderProps = {
  message?: string;
};

const MotionBox = motion.create(Box);

const transition = {
  duration: 0.22,
  ease: [0.4, 0, 0.2, 1],
} as const;

export const InitialPageLoader: React.FC<InitialPageLoaderProps> = ({
  message = 'Preparing your workspace...',
}) => {
  const reduceMotion = useReducedMotion();

  return (
    <Box
      sx={{
        minHeight: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
      }}>
      <MotionBox
        initial={reduceMotion ? false : { opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={reduceMotion ? { duration: 0 } : transition}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          textAlign: 'center',
        }}>
        <CircularProgress size={30} />
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </MotionBox>
    </Box>
  );
};

InitialPageLoader.propTypes = {
  message: PropTypes.string,
};
